import axios      from 'axios';
import classNames from 'classnames';
import * as React from 'react';

import Dropdown from '../../../components/fields/dropdown';

import { useCatalog } from '../../../providers/catalog';

const SortingSelect = (props) => {
  const {
          sort,
          sortItemsFn,
          className,
        } = props;

  const catalog = useCatalog();

  const [sortingItems, setSortingItems]       = React.useState([]);
  const [sortingIsLoaded, setSortingIsLoaded] = React.useState(false);

  React.useEffect(() => {
    if (!sortingIsLoaded) {
      axios.get('/catalog-sorting/list')
        .then((response) => {
          setSortingItems(response.data.vars.items.map((item) => {
            return {
              label: item.label,
              value: item.alias,
            };
          }));
          setSortingIsLoaded(true);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [sortingIsLoaded]);

  if (!sortingIsLoaded) {
    return null;
  }

  return (
    <div
      className={classNames('sorting_select', className, {
        sortingHidden: !catalog.filter.open,
      })}
    >
      <Dropdown
        labelKey={'label'}
        onChangeCallback={sortItemsFn}
        options={sortingItems}
        selected={sort}
        valueKey={'value'}
      />
    </div>
  );
};

export default SortingSelect;